module.exports = __webpack_public_path__ + "img/award_no.1ff2fa40.png";